import { ReactElement } from "react"
import styled from "@emotion/styled"
import { BulletPointProps } from "../../types"

function BulletPoint({ bp }: BulletPointProps): ReactElement {
  return (
    <BPWrapper>
      <BPIconTitleWrapper>
        <BPIconWrapper>{bPIcon}</BPIconWrapper>
        <BPTitleWrapper>{bp.title}</BPTitleWrapper>
      </BPIconTitleWrapper>

      <BPBodyWrapper>{bp.body}</BPBodyWrapper>
    </BPWrapper>
  )
}

const BPWrapper = styled.div`
  position: relative;

  padding: 0.5rem;
  border-radius: 0.5rem;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.2rem;

  text-align: start;
  user-select: none;

  @media screen and (min-width: 900px) {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }

  background: linear-gradient(
    160deg,
    rgba(243, 243, 236, 0.1) 60%,
    var(--primary)
  );
`

const BPIconTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`

const BPIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 36px;
  height: 36px;

  transform: rotate(-12deg);
`

const BPTitleWrapper = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: var(--purpleText);
`

const BPBodyWrapper = styled.div`
  position: relative;
  top: 1px;

  font-size: 14px;
  font-weight: 500;

  color: var(--white);
  text-align: start;
`

const bPIcon = (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36 48L44 56L62 38M29.3351 15.2748C32.5504 15.0182 35.6029 13.7538 38.0579 11.6617C43.7869 6.77944 52.2131 6.77944 57.9421 11.6617C60.3971 13.7538 63.4496 15.0182 66.6649 15.2748C74.1682 15.8735 80.1264 21.8318 80.7252 29.3351C80.9818 32.5504 82.2462 35.6029 84.3383 38.0579C89.2206 43.7869 89.2206 52.2131 84.3383 57.9421C82.2462 60.3971 80.9818 63.4496 80.7252 66.6649C80.1264 74.1682 74.1682 80.1264 66.6649 80.7252C63.4496 80.9818 60.3971 82.2462 57.9421 84.3383C52.2131 89.2206 43.7869 89.2206 38.0579 84.3383C35.6029 82.2462 32.5504 80.9818 29.3351 80.7252C21.8318 80.1264 15.8735 74.1682 15.2748 66.6649C15.0182 63.4496 13.7538 60.3971 11.6617 57.9421C6.77944 52.2131 6.77944 43.7869 11.6617 38.0579C13.7538 35.6029 15.0182 32.5504 15.2748 29.3351C15.8735 21.8318 21.8318 15.8735 29.3351 15.2748Z"
      stroke="#db971a"
      // stroke="#f2f2eb"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default BulletPoint
